// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"oJ-z","carousel":"pJ-z"};